import React from 'react'
import NavBar from '../Components/NavBar'
import Hero from '../Components/Hero'
import AboutSection from '../Components/AboutSection'
import VisionMission from '../Components/VisionMission'
import Capabilities from '../Components/Capabilities'
import Services from '../Components/Services'
import Partners from '../Components/Partners'
import Differentiators from '../Components/Differentiators'
import Sectors from '../Components/Sectors'
import Contact from '../Components/Contact'
import Footer from '../Components/Footer'
import Clients from '../Components/Clients'
import Clients2 from '../Components/Clients2'

function Home() {
  return (
    <div className="font-sans antialiased">
      <NavBar />
      <Hero />
      <AboutSection />
      <VisionMission />
      <Capabilities />

      {/* <Services /> */}
      {/* <Partners />  */}
      <Differentiators />
      <Clients2 />
      {/* <Clients /> */}
      <Footer />
    </div>
  )
}

export default Home
